// Shared formatting + status helpers
export function fmtDuration(sec) {
  if (sec == null) return "—";
  sec = Math.max(0, Math.floor(sec));
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  if (h > 0) return `${h}h ${String(m).padStart(2, "0")}m`;
  return `${m}m ${String(s).padStart(2, "0")}s`;
}

export function fmtClock(sec) {
  sec = Math.max(0, Math.floor(sec || 0));
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return h > 0 ? `${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
}

export function fmtTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: false });
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: false });
}

export const STATUS_META = {
  working: { label: "Working", bg: "#ECFDF5", text: "#065F46", dot: "#10B981" },
  on_break: { label: "On Break", bg: "#FFFBEB", text: "#92400E", dot: "#F59E0B" },
  excess: { label: "Excess Break", bg: "#FEF2F2", text: "#991B1B", dot: "#EF4444" },
  meeting: { label: "Meeting / Training", bg: "#EFF6FF", text: "#1E40AF", dot: "#3B82F6" },
  away: { label: "Away", bg: "#F3F4F6", text: "#374151", dot: "#6B7280" },
  offline: { label: "Offline", bg: "#F3F4F6", text: "#6B7280", dot: "#9CA3AF" },
};

export function statusMeta(s) {
  return STATUS_META[s] || STATUS_META.offline;
}

export function toCSV(rows, filename) {
  if (!rows.length) return;
  const headers = Object.keys(rows[0]);
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const csv = [headers.join(","), ...rows.map((r) => headers.map((h) => esc(r[h])).join(","))].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
